.buttonWrapper {
  position: absolute;

  /* Высота шапки 44px + 16px отступ от верха */
  top: 60px;
  left: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 1000;

  & .button {
    background-color: var(--history-button-bg);

    &:hover {
      background-color: var(--history-button-bg);
    }
  }
}
